export default __webpack_public_path__ + "56cb06a5709669628e40f0bc945b4a97.svg";